(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ConstructionController', ConstructionController);

    ConstructionController.$inject = ['previousState'];

    function ConstructionController (previousState) {
        var vm = this;
        vm.previousState = previousState.name;

    }
})();
